module.exports = __webpack_public_path__ + "img/fortmatic.578077d6.svg";